/**
 * @see https://umijs.org/zh-CN/plugins/plugin-access
 * */
export default function access(initialState: { currentUser?: API.CurrentUser } | undefined) {
  const { currentUser } = initialState ?? {};
  return {
    canConvo: currentUser?.pages && currentUser.pages?.indexOf('conversations') > -1,
    canDashboard: currentUser?.pages && currentUser.pages?.indexOf('dashboard') > -1,
    canBroadcast: currentUser?.pages && currentUser.pages?.indexOf('broadcast') > -1,
    canFlow: currentUser?.pages && currentUser.pages?.indexOf('flows') > -1,
    canQuestion: currentUser?.pages && currentUser.pages?.indexOf('questions') > -1,
    canNlp: currentUser?.pages && currentUser.pages?.indexOf('nlp') > -1,
    canDictionary: currentUser?.pages && currentUser.pages?.indexOf('dictionary') > -1,
    canEntity: currentUser?.pages && currentUser.pages?.indexOf('entity') > -1,
    canEmail: currentUser?.pages && currentUser.pages?.indexOf('email') > -1,
    canFiles: currentUser?.pages && currentUser.pages?.indexOf('files') > -1,
    canLibrary: currentUser?.pages && currentUser.pages?.indexOf('library') > -1,
    canChat: currentUser?.pages && currentUser.pages?.indexOf('chat') > -1,
    canAnalysis: currentUser?.pages && currentUser.pages?.indexOf('chat') > -1,
    canSearch: currentUser?.pages && currentUser.pages?.indexOf('search') > -1,
    canTemplate: currentUser?.pages && currentUser.pages?.indexOf('template') > -1,
    canSetting: currentUser?.pages && currentUser.pages?.indexOf('setting') > -1,
    canAiSetting: currentUser?.pages && currentUser.pages?.indexOf('ai_settings') > -1,
    canDiagnostics: currentUser?.pages && currentUser.pages?.indexOf('diagnostics') > -1,
    canQuote: currentUser?.pages && currentUser.pages?.indexOf('quote') > -1,
    canReview: currentUser?.pages && currentUser.pages?.indexOf('review') > -1,
    canMatrix: currentUser?.pages && currentUser.pages?.indexOf('matrix') > -1,
    canContext: currentUser?.pages && currentUser.pages?.indexOf('context') > -1,
    canComparison: currentUser?.pages && currentUser.pages?.indexOf('comparison') > -1,
    canTranslation: currentUser?.pages && currentUser.pages?.indexOf('translation') > -1,
    canAdmin: currentUser?.pages && currentUser.pages?.indexOf('admin') > -1,
    canManagement: currentUser?.pages && currentUser.pages?.indexOf('management') > -1,
    isSuperAdmin: currentUser && currentUser.isSuperAdmin,
    isAdmin: currentUser && currentUser.role === 'admin',
  };
}
